import { v1 as uuidv1 } from 'uuid';

export default () => uuidv1();
